import React from "react";
import Skeleton from "../../Common/Skeleton";

const MarketPricesSkeleton = ({ itemCount = 7 }) => {
  return (
    // <div className="w-full max-w-sm rounded-2xl bg-skeleton-end dark:bg-[#2a302b] shadow-xl">
    <div className="w-full max-w-sm rounded-2xl bg-skeleton-end shadow-xl">
      {/* Header Skeleton */}
      <div className="flex items-center justify-between pb-4 p-3.5">
        <Skeleton className="h-6 w-32 animate-pulse rounded-md" />
        <Skeleton className="h-4 w-20 animate-pulse rounded-md" />
      </div>

      <div className="bg-divider p-[0.5px]" />

      {/* Rows List */}
      <div className="divide-y divide-divider pb-3">
        {Array.from({ length: itemCount }).map((_, index) => (
          <div
            key={index}
            className="flex items-center justify-between py-[13px] last:pb-0 px-4"
            // className="flex items-center justify-between last:pb-0 p-3"
          >
            {/* Left: Logo + Coin Name */}
            <div className="flex items-center gap-2">
              {/* Circular Logo Skeleton */}
              <Skeleton className="h-9 w-9 shrink-0 animate-pulse rounded-full" />
              {/* Coin Name Skeleton */}
              <Skeleton className="h-4 w-20 animate-pulse rounded-md" />
            </div>

            {/* Middle: Sparkline Chart Skeleton */}
            <Skeleton className="mx-2 h-10 w-20 shrink-0 animate-pulse rounded-md" />

            {/* Right: Price & Percentage Change */}
            <div className="flex flex-col items-end gap-1.5">
              {/* Price Skeleton */}
              <Skeleton className="h-4 w-16 animate-pulse rounded-md" />
              {/* Change % Skeleton */}
              <Skeleton className="h-3 w-10 animate-pulse rounded-md" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MarketPricesSkeleton;